import { useState, useEffect } from "react";
import styled from "styled-components";

interface CounterInputProps {
  min: number;
  max: number;
  defaultValue?: number;
  onChange: (value: number) => void;
}

const CounterInput = ({ min, max, defaultValue = 2, onChange }: CounterInputProps) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    onChange(value);
  }, [value]);

  const decrement = (e: React.MouseEvent) => {
    e.stopPropagation();
    setValue((v) => Math.max(min, v - 1));
  };

  const increment = (e: React.MouseEvent) => {
    e.stopPropagation();
    setValue((v) => Math.min(max, v + 1));
  };

  return (
    <Wrapper onClick={(e) => e.stopPropagation()}>
      <button className="counter-btn" onClick={decrement} disabled={value <= min}>
        −
      </button>
      <span className="counter-value">{value}</span>
      <button className="counter-btn" onClick={increment} disabled={value >= max}>
        +
      </button>
    </Wrapper>
  );
};

export default CounterInput;

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0 4px;

  .counter-btn {
    width: 24px;
    height: 24px;
    border: 1px solid ${({ theme }) => theme.border_color || "#ddd"};
    border-radius: 6px;
    background: ${({ theme }) => theme.widget.background};
    color: ${({ theme }) => theme.text};
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;

    &:hover:not(:disabled) {
      background: ${({ theme }) => theme.body};
    }

    &:disabled {
      opacity: 0.3;
      cursor: default;
    }
  }

  .counter-value {
    min-width: 20px;
    text-align: center;
    font-weight: 600;
    font-size: 14px;
  }
`;
